// Central media map — every image is used EXACTLY ONCE across the whole site.
// Real AIM job photos + AI-rendered premium Colts Neck / Monmouth County homes.
// Files live in /public/images/aim and are referenced by absolute path.
const B = "/images/aim";
const p = (n) => `${B}/${n}`;

export const HOME_HERO_SLIDES = [
  { src: p("ai-twilight.jpg"), label: "Roofing & Exteriors" },
  { src: p("hh_kitchen.jpg"), label: "Kitchens & Baths" },
  { src: p("hh_commercial.jpg"), label: "Commercial Build-Outs" },
  { src: p("hh_basement.jpg"), label: "Basements & Finishing" },
];

export const HOME_ABOUT_IMAGE = p("ai-street.jpg");
export const AREAS_HERO_IMAGE = p("ai-aerial.jpg");

const g = (arr) => arr.map(p);

export const SERVICE_MEDIA = {
  roofing: {
    hero: p("hero_roofing.jpg"),
    card: p("card_roofing.jpg"),
    before: p("ba_roofing_before.jpg"),
    after: p("ba_roofing_after.jpg"),
    gallery: g(["ext-colonial-1.jpg", "ext-colonial-2.jpg", "ext-stone-1.jpg", "g_roofing_1.jpg", "g_roofing_2.jpg", "g_roofing_3.jpg"]),
  },
  siding: {
    hero: p("hero_siding.jpg"),
    card: p("card_siding.jpg"),
    before: p("ba_siding_before.jpg"),
    after: p("ba_siding_after.jpg"),
    gallery: g(["ext-stone-porch.jpg", "ext-stone-2.jpg", "ext-stone-3.jpg", "ext-during-1.jpg", "g_siding_1.jpg", "g_siding_2.jpg"]),
  },
  gutters: {
    hero: p("hero_gutters.jpg"),
    card: p("card_gutters.jpg"),
    before: p("ba_gutters_before.jpg"),
    after: p("ba_gutters_after.jpg"),
    gallery: g(["ext-colonial-3.jpg", "g_gutters_1.jpg", "g_gutters_2.jpg", "g_gutters_3.jpg", "g_gutters_4.jpg"]),
  },
  "kitchen-remodeling": {
    hero: p("kitchen-1.jpg"),
    card: p("card_kitchen.jpg"),
    before: p("ba_kitchen_before.jpg"),
    after: p("ba_kitchen_after.jpg"),
    gallery: g(["kitchen-2.jpg", "kitchen-3.jpg", "kitchen-4.jpg", "kitchen-5.jpg", "kitchen-6.jpg", "g_kitchen_1.jpg"]),
  },
  "bathroom-remodeling": {
    hero: p("bath-modern-1.jpg"),
    card: p("card_bathroom.jpg"),
    before: p("ba_bathroom_before.jpg"),
    after: p("ba_bathroom_after.jpg"),
    gallery: g(["bath-modern-2.jpg", "bath-modern-3.jpg", "bath-modern-4.jpg", "bath-modern-5.jpg", "bath-sage-1.jpg", "bath-sage-2.jpg", "bath-sage-3.jpg", "bath-sage-4.jpg", "bath-marble-shower.jpg", "bath-marble-vanity.jpg"]),
  },
  "basement-finishing": {
    hero: p("basement_hero.jpg"),
    card: p("basement_card.jpg"),
    before: p("ba_basement_before.jpg"),
    after: p("ba_basement_after.jpg"),
    gallery: g(["basement-3.jpg", "basement-4.jpg", "interior-1.jpg", "interior-2.jpg", "g_basement_1.jpg"]),
  },
  "general-maintenance": {
    hero: p("ai-facility.jpg"),
    card: p("card_maintenance.jpg"),
    before: p("ba_maintenance_before.jpg"),
    after: p("ba_maintenance_after.jpg"),
    gallery: g(["g_maint_1.jpg", "g_maint_2.jpg", "g_maint_3.jpg", "g_maint_4.jpg"]),
  },
  "restaurant-build-outs": {
    hero: p("rest-1.jpg"),
    card: p("card_restaurant.jpg"),
    before: p("ba_restaurant_before.jpg"),
    after: p("ba_restaurant_after.jpg"),
    gallery: g(["rest-2.jpg", "rest-3.jpg", "rest-4.jpg", "rest-5.jpg", "rest-6.jpg", "rest-7.jpg", "rest-8.jpg"]),
  },
  "retail-storefronts": {
    hero: p("ai-retail.jpg"),
    card: p("card_retail.jpg"),
    before: p("ba_retail_before.jpg"),
    after: p("ba_retail_after.jpg"),
    gallery: g(["g_retail_1.jpg", "g_retail_2.jpg", "g_retail_3.jpg", "g_retail_4.jpg"]),
  },
};
